var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0785 6.31125C0.973833 6.11725 0.973833 5.88192 1.0785 5.68792C2.33983 3.35525 4.66983 1.33325 6.99983 1.33325C9.32983 1.33325 11.6598 3.35525 12.9212 5.68859C13.0258 5.88259 13.0258 6.11792 12.9212 6.31192C11.6598 8.64459 9.32983 10.6666 6.99983 10.6666C4.66983 10.6666 2.33983 8.64459 1.0785 6.31125Z",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41421 4.58579C9.19526 5.36683 9.19526 6.63316 8.41421 7.41421C7.63316 8.19526 6.36683 8.19526 5.58579 7.41421C4.80474 6.63316 4.80474 5.36683 5.58579 4.58579C6.36683 3.80474 7.63316 3.80474 8.41421 4.58579",
    stroke: "#8E8D89",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityIcon);
export default __webpack_public_path__ + "static/media/VisibilityIcon.8fa27048d0fd2244ac06af707962a22a.svg";
export { ForwardRef as ReactComponent };